import { type FC } from 'react'
import classNames from 'classnames'
import { type ReminderInfo } from '../../../models/Scheduling'
import { getReminderStatusView } from '../bookingFormat'

interface ReminderStatusProps {
  reminder?: ReminderInfo
}

export const ReminderStatus: FC<ReminderStatusProps> = ({ reminder }) => {
  const view = getReminderStatusView(reminder)
  if (view == null) {
    return null
  }
  return (
    <div className='d-flex flex-column align-items-end flex-shrink-0 text-end zocks-gap-0.125'>
      {view.badge ? (
        <span
          className={classNames(
            'paragraph-small rounded-3 px-2 zocks-py-0.125 text-nowrap',
            view.badge.variant === 'exhausted'
              ? 'zocks-bg-color-danger-background zocks-text-danger-200'
              : 'zocks-bg-color-primary-light zocks-text-primary-dark',
          )}
        >
          {view.badge.label}
        </span>
      ) : null}
      {view.note ? <span className='paragraph-small zocks-text-gray-700 text-nowrap'>{view.note}</span> : null}
    </div>
  )
}
